module.exports = __webpack_public_path__ + "bb67538f6f68819e3ad0f4d0f7fd3bef.pdf";